module.exports = __webpack_public_path__ + "03_mole.6f005620.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/03_mole.png
// module id = KxdM
// module chunks = 0